import styled from "@mui/material/styles/styled";

import Button, { ButtonProps } from "@rui/Button";
import { Row, StackProps } from "@rui/Stack";

export const NoteSectionActionButton = styled((props) => (
  <Button variant="text" size="small" {...props} />
))<ButtonProps>(({ theme }) => ({
  padding: theme.spacing(1),
  height: "32px",
  borderRadius: "4px",
  fontSize: "12px",
  "& svg": {
    height: "16px",
    width: "16px",
  },
  color: theme.palette.shades.neutral[300],
  "&:hover": {
    color: theme.palette.shades.primary[500],
    backgroundColor: theme.palette.shades.ghost[500],
  },
}));

type BulletedListItemContainerProps = StackProps & { isPrivate?: boolean };

export const BulletedListItemContainer = styled(
  ({ isPrivate, children, ...props }: BulletedListItemContainerProps) => (
    <Row variant="apart" {...props}>
      {children}
      {isPrivate && <span>🔒</span>}
    </Row>
  )
)(({ theme, isPrivate }) => ({
  width: "100%",
  paddingRight: theme.spacing(1),
  marginBottom: theme.spacing(0.5),
  ...(isPrivate && {
    backgroundColor: theme.palette.shades.ghost[300],
    borderRadius: "4px",
  }),
}));
